import { firestore } from "./firebase";
import { collection, addDoc, serverTimestamp, setDoc, getDoc, updateDoc, query, orderBy, limit, doc } from 'firebase/firestore';

export class FirestoreClient {
    
    #firestore;
    #uid;

    constructor(uid) {
        this.#uid = uid;
        this.#firestore = firestore;
    }

    /*
    from a computational standpoint, the references dont change, right?
    would it make sense to just store them in instance vars then?
    */

    get sessionDocRef() {
        return doc(this.#firestore, 'sessions', this.#uid);
    }

    get messagesCollectionRef() {
        return collection(this.sessionDocRef, 'messages');
    }

    get lastMessagesQuery() {
        return query(this.messagesCollectionRef, orderBy('createdAt', 'desc'), limit(25));
    }

    async loginUserSession() {
        /*
        This method should be called after creating the FirestoreClient instance

        if initial login, create userSessionDoc
        else just update lastLogin
        */
        const sessionDocRef = this.sessionDocRef
        const docSnap = await getDoc(sessionDocRef);

        if (!docSnap.exists()) {
            await setDoc(sessionDocRef, {
                authenticatedStudents: [],
                getUpdates: true,
                isBlocked: false,
                lastLogin: serverTimestamp()
            });
        } else {
            await updateDoc(sessionDocRef, {
                lastLogin: serverTimestamp()
            });
        }
    }
    
    async createUserMessage(text) {
        return addDoc(this.messagesCollectionRef, {
            createdAt: serverTimestamp(),
            fileUrl: "",
            type: "text",
            isBot: false,
            text: text,
        })
    }
}
